import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface RatingStarProps {
  isSelected?: boolean;
  isHover?: boolean;
  style?: React.CSSProperties;
}

export default function BugReportIcon({ isSelected = false, isHover = false, style = {}, ...props }: RatingStarProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 21 20" style={{ width: `20px`, height: `20px`, ...style }}>
      <path
        d="M3.55261 12.5844C3.55261 12.5844 4.41409 11.723 6.99854 11.723C9.58298 11.723 11.3059 13.4459 13.8904 13.4459C16.4748 13.4459 17.3363 12.5844 17.3363 12.5844V2.24667C17.3363 2.24667 16.4748 3.10815 13.8904 3.10815C11.3059 3.10815 9.58298 1.38519 6.99854 1.38519C4.41409 1.38519 3.55261 2.24667 3.55261 2.24667V12.5844Z"
        fill={isHover ? RoutalPalette.primary20 : isSelected ? RoutalPalette.primary40 : RoutalPalette.secondary40}
        stroke={isHover ? RoutalPalette.primary20 : isSelected ? RoutalPalette.primary40 : RoutalPalette.secondary40}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.55261 18.6148V12.5844"
        stroke={isHover ? RoutalPalette.primary20 : isSelected ? RoutalPalette.primary40 : RoutalPalette.secondary40}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
